import FarmerCard from "./FarmerCard";

function FarmerSelectPage({ farmersData, phoneNumber, otp }) {
  return (
    <div className="EnterphoneNumber lg:w-[36vw] flex flex-col justify-center items-center rounded-[40px] neo overflow-hidden bg-[#E9F0F7] ">
      <div className="Backgreen w-full flex flex-col justify-center items-center rounded-[60px] max-lg:w-[92vw] p-16 max-lg:p-8 gap-8 max-lg:gap-8">
        <p className=" text-center text-agroyar text-[54px] max-lg:text-[2rem] font-bold">
          ورود به عنوان
        </p>

        <p className=" text-center  max-lg:w-[300px] text-[#6c6c6c] text-[13px] font-medium lg:whitespace-nowrap">
          کارشناس گرامی لطفا کشاورزی را که میخواهید به داشبورد آن وارد شوید را
          انتخاب نمایید.{" "}
        </p>

        {farmersData && (
          <div className="w-full max-h-[350px] overflow-y-scroll flex flex-col gap-4 p-3">
            <FarmerCard data={farmersData?.profile} />
            {farmersData?.hasAccessFarmers?.map((item, i) => {
              return (
                <FarmerCard
                  phoneNumber={phoneNumber}
                  otp={otp}
                  key={i}
                  data={item?.farmer}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default FarmerSelectPage;
